import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import styles from './Contact.module.css';

// Добавляем функцию для отправки событий в Яндекс.Метрику
const sendMetrikaEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.ym) {
    window.ym(105284877, 'reachGoal', eventName, eventParams);
  }
};

// Кастомный хук для маски телефона (если usePhoneMask не работает)
const usePhoneMask = () => {
  const [phone, setPhone] = useState('');

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    
    if (value.length > 0) {
      value = value.substring(0, 11);
      let formattedValue = '+7';
      
      if (value.length > 1) {
        formattedValue += ` (${value.substring(1, 4)}`;
      }
      if (value.length >= 5) {
        formattedValue += `) ${value.substring(4, 7)}`;
      }
      if (value.length >= 8) {
        formattedValue += `-${value.substring(7, 9)}`;
      }
      if (value.length >= 10) {
        formattedValue += `-${value.substring(9, 11)}`;
      }
      
      setPhone(formattedValue);
    } else {
      setPhone('');
    }
  };

  return [phone, handlePhoneChange];
};

const Contact = () => {
  const [isOpenThanks, setIsOpenThanks] = useState(false);
  const [phone, handlePhoneChange] = usePhoneMask(); // Используем кастомный хук
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [checkBox, setCheckBox] = useState(true);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const phoneRegExp = /^\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateForm = () => {
    const newErrors = {};
    
    if (!phoneRegExp.test(phone)) {
      newErrors.phone = 'Введите корректный номер телефона';
    }
    
    if (!emailRegex.test(email)) {
      newErrors.email = 'Введите корректный email адрес';
    }
    
    if (!checkBox) {
      newErrors.checkBox = 'Примите соглашение';
    }
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      
      // Отслеживаем ошибки валидации формы
      sendMetrikaEvent('consultation_validation_error', {
        form_type: 'contact_form',
        errors: validationErrors
      });
      
      setIsSubmitting(false);
      return;
    }

    try {
      // Отправляем событие в Яндекс.Метрику при успешной валидации формы
      sendMetrikaEvent('consultation_order', {
        form_type: 'contact_form',
        phone_provided: !!phone,
        email_provided: !!email,
        name_provided: !!name,
        message_provided: !!message,
        source: 'contact_section'
      });

      // Отправка через EmailJS
      const templateParams = {
        phone,
        email,
        name,
        message
      };

      await emailjs.send(
        'service_f3d3gpm',
        'template_46r6p8s',
        templateParams,
        '9UYBO40lGP0XwuZ7m'
      );
      
      // Дополнительное событие при успешной отправке на сервер
      sendMetrikaEvent('consultation_success', {
        form_type: 'contact_form',
        status: 'success'
      });

      // Сброс формы и показ сообщения об успехе
      handlePhoneChange('');
      setEmail('');
      setName('');
      setMessage('');
      setCheckBox(true);
      setErrors({});
      setIsOpenThanks(true);
      
      // Автоматическое закрытие сообщения об успехе через 5 секунд
      setTimeout(() => {
        setIsOpenThanks(false);
      }, 5000);
      
    } catch (error) {
      console.error('Ошибка при отправке', error);
      
      // Событие при ошибке отправки
      sendMetrikaEvent('consultation_error', {
        form_type: 'contact_form',
        status: 'error',
        error_type: 'emailjs_failed'
      });
      
      setErrors({ submit: 'Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Сброс ошибки при изменении поля
  const handleFieldChange = (field, value, setter) => {
    setter(value);
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  // Простая модалка для сообщения об успехе
  const SuccessModal = () => {
    if (!isOpenThanks) return null;
    
    return (
      <div className={styles.successModal}>
        <div className={styles.successModalContent}>
          <div className={styles.successIcon}>✓</div>
          <h3>Спасибо за заявку!</h3>
          <p>Мы свяжемся с вами в ближайшее время</p>
          <button 
            className={styles.successCloseBtn}
            onClick={() => setIsOpenThanks(false)}
          >
            Закрыть
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <section id="contact" className={`section ${styles.contact}`}>
        <div className="container">
          <div className={styles.contactContent}>
            <div className={styles.contactInfo}>
              <h2 className={styles.sectionTitle}>Свяжитесь с нами</h2>
              <p className={styles.sectionSubtitle}>
                Получите консультацию или закажите документы
              </p>
              
              <div className={styles.contactItems}>
                <div className={styles.contactItem}>
                  <i className="fa fa-phone"></i>
                  <div>
                    <h4>Телефон</h4>
                    <a href="tel:+79874817932">+7 (987) 481-79-32</a>
                  </div>
                </div>
                
                <div className={styles.contactItem}>
                  <i className="fa fa-envelope"></i>
                  <div>
                    <h4>Email</h4>
                    <a href="mailto:mirat7932@mail.ru">mirat7932@mail.ru</a>
                  </div>
                </div>
                
                <div className={styles.contactItem}>
                  <i className="fa fa-clock-o"></i>
                  <div>
                    <h4>Режим работы</h4>
                    <p>Круглосуточно, без выходных</p>
                  </div>
                </div>
              </div>
              
              <div className={styles.socialLinks}>
                <a href="https://wa.me/79874817932" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-whatsapp"></i>
                </a>
                <a href="https://t.me/regioncheck" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-telegram"></i>
                </a>
                <a href="viber://chat?number=+79874817932" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-phone"></i>
                </a>
              </div>
            </div>
            
            <div className={styles.contactForm}>
              <div className={`card ${styles.contactFormCard}`}>
                <h3>Быстрый заказ</h3>
                <p>Оставьте заявку и мы свяжемся с вами в течение 15 минут</p>
                
                <form className={styles.form} onSubmit={handleSubmit}>
                  <div className={styles.formGroup}>
                    <input 
                      type="text" 
                      placeholder="Ваше имя" 
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className={errors.name ? styles.inputError : ''}
                    />
                  </div>
                  
                  <div className={styles.formGroup}>
                    <input 
                      type="tel" 
                      placeholder="Телефон *" 
                      required
                      value={phone}
                      onChange={handlePhoneChange}
                      inputMode="numeric"
                      className={errors.phone ? styles.inputError : ''}
                    />
                    {errors.phone && <span className={styles.error}>{errors.phone}</span>}
                  </div>
                  
                  <div className={styles.formGroup}>
                    <input 
                      type="email" 
                      placeholder="Email *" 
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={errors.email ? styles.inputError : ''}
                    />
                    {errors.email && <span className={styles.error}>{errors.email}</span>}
                  </div>
                  
                  <div className={styles.formGroup}>
                    <textarea 
                      placeholder="Сообщение или комментарий" 
                      rows="4"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>
                  
                  <div className={styles.formGroup}>
                    <label className={styles.Contact_formGroup_checkboxLabel}>
                      {/* <input
                        type="checkbox"
                        checked={checkBox}
                        onChange={(e) => setCheckBox(e.target.checked)}
                        className={`${styles.checkbox} ${errors.checkBox ? styles.checkboxError : ''}`}
                      /> */}
                      
                      <span>
                      </span>
                      <span>
                        Отправляя форму, вы соглашаетесь с{' '}
                        <span className={styles.privacyLink}>
                          политикой конфиденциальности
                        </span>
                      </span>
                    </label>
                    {errors.checkBox && <span className={styles.error}>{errors.checkBox}</span>}
                  </div>
                  
                  {errors.submit && (
                    <div className={styles.formGroup}>
                      <span className={styles.submitError}>{errors.submit}</span>
                    </div>
                  )}
                  
                  <button
                    className={`btn btn-primary ${isSubmitting ? styles.submitting : ''}`}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fa fa-spinner fa-spin"></i> Отправка...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane"></i> Отправить заявку
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SuccessModal />
    </>
  );
};

export default Contact;